var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLeftarrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 19,
  height: 34,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#E85298",
  fillRule: "evenodd",
  d: "M.773 32.657a1.5 1.5 0 0 1 0-2.121l13.94-13.94L.773 2.657A1.5 1.5 0 1 1 2.895.536l16.06 16.06-16.06 16.061a1.5 1.5 0 0 1-2.122 0Z",
  clipRule: "evenodd"
})));
export default SvgLeftarrow;